import { ReactRouteObject } from "base/src/utils/routeUtil"
import { BaseRouter } from "base/src/infra/routes/baseRoutes"

import HomePage from "../../views/Home";
import Configuracoes from "../../views/Configuracoes/Configuracoes";
import Deposito from "../../views/Deposito";
import Premiacao from "domain/views/_carteira/Premiacao";
import Extrato from "../../views/Extrato";
import HistoricoPagamento from "../../views/HistoricoPagamento";
import DetalhePagamento from "../../views/DetalhePagamento";
import BoletoGestao from "../../views/BoletoGestao";
import CarteiraAdmin from "../../views/CarteiraAdmin/carteiraAdmin";

export const CarteiraRouter: ReactRouteObject[] = [
  ...BaseRouter,
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "extrato",
    element: <Extrato />,
  },
  {
    path: "deposito",
    element: <Deposito />,
  },
  {
    path: "premiacao",
    element: <Premiacao />,
  },
  {
    path: "configuracao",
    element: <Configuracoes />,
  },
  {
    path: "pagamento/:id",
    element: <DetalhePagamento />,
  },
  {
    path: "pagamento/historico",
    element: <HistoricoPagamento />,
  },
  {
    path: "boletos",
    element: <BoletoGestao />,
  },
  {
    path: "admin",
    element: <CarteiraAdmin/>,
    initialState: false,
  }
];
